"use client";

import BannerPage from "@/components/banners/BannerTitle";
import { useLanguage } from "@/contexts/LanguageContext";
import type { Apartment, Room } from "@/payload-types";
import getImageUrl from "@/utils/getImageUrl";
import type { PayLoadData } from "@/utils/payloadUtil";

type Props = {
  detail: PayLoadData<Apartment | Room> | undefined;
};

export default function DetailPageClient({ detail }: Props) {
  const { language } = useLanguage();

  return (
    <BannerPage
      bannerUrl={getImageUrl(detail?.[language]?.featuredImage)}
      title={detail?.[language]?.name || ""}
      desc={detail?.[language]?.type || ""}
    />
  );
}
